import createSearchInstanceSlice from './createSearchInstanceSlice';

const { reducer, actions, fetchSearchResults } = createSearchInstanceSlice({
	instanceName: 'QuestionsAndAnswers',
	initialState: {
		searchResults: null,
		fetchStatus: '',
		showMoreResultsFectchStatus: '',
		sortOrder: 1,
		pageSize: 3,
		pageNumber: 1,
		previousPageNumber: 1,
		searchTerm: '',
		totalResultsCount: 0,
		totalResultsLeft: 0
	}
});

const { emptySearchResults, newSearchResults, showMoreResults } = actions;

export {
	fetchSearchResults, emptySearchResults, newSearchResults, showMoreResults
};
export default reducer;
